import { useQuery } from 'react-query';

import { GetRecentSubsetAccessResponseDto } from '../../../../backend/src/subset/dto/get-recent-subsets.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { ApiError } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetRecentSubsets = (matterId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<GetRecentSubsetAccessResponseDto[]>(
    [QueryEntity.RecentSubsets, { matterId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/recent`, fetchConfigGET);
      if (!res.ok) {
        console.error('Failed to get recent subsets');
      }
      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!matterId,
    },
  );
};
